import { render, staticRenderFns } from "./unusual.vue?vue&type=template&id=5a2c0c01&scoped=true&"
import script from "./unusual.vue?vue&type=script&lang=js&"
export * from "./unusual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2c0c01",
  null
  
)

export default component.exports